module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 m-t-30\">\r\n            <p>Please wait while we are verifying your account...</p>            \r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/account/confirm/account.confirm.component.html
// module id = ./src/components/account/confirm/account.confirm.component.html
// module chunks = main